__turbopack_context__.v({
  "badge": "PlatformInfo-module-scss-module__3tAKda__badge",
  "card": "PlatformInfo-module-scss-module__3tAKda__card",
  "checkIcon": "PlatformInfo-module-scss-module__3tAKda__checkIcon",
  "commissionItem": "PlatformInfo-module-scss-module__3tAKda__commissionItem",
  "commissions": "PlatformInfo-module-scss-module__3tAKda__commissions",
  "container": "PlatformInfo-module-scss-module__3tAKda__container",
  "containerWarehouse": "PlatformInfo-module-scss-module__3tAKda__containerWarehouse",
  "content": "PlatformInfo-module-scss-module__3tAKda__content",
  "description": "PlatformInfo-module-scss-module__3tAKda__description",
  "link": "PlatformInfo-module-scss-module__3tAKda__link",
  "textGroup": "PlatformInfo-module-scss-module__3tAKda__textGroup",
  "title": "PlatformInfo-module-scss-module__3tAKda__title",
});
